<template>

  <b-container fluid v-if="datosCita !== undefined && datosCita !== null">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active="loadingGuardar"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
<!-- {{datosCita}} -->
<!--    <b-tabs content-class="mt-2" pills  class="roundTabs mt-3">-->
<!--      <b-tab title="Info. de la cita" active>-->

        <b-row>
          <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2">
            <div class="detalle-formulario-titulo">
              <span>Información de la cita</span>
            </div>
          </b-col>
          <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2" style="text-align: right;">
            <b-button class="button-dentalia-svg-2" variant="primary"
                      title="Limpiar formulario" @click="limpiarFormulario">
              <em class="limpiar_svg icon-dentalia-svg-2"></em>
            </b-button>
          </b-col>
        </b-row>

        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(guardarCita)">

            <b-row class="detalle-formulario">

              <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2">

                <label>Motivo Cita<validacion v-if="editarFull"/></label>

                <div v-if="!editarFull">
                  <span>{{ datosCita.tagMotivoCita !== undefined && datosCita.tagMotivoCita !== null && datosCita.tagMotivoCita !== '' ? datosCita.tagMotivoCita : "--SIN DATO--" }}</span>
                </div>
                <validation-provider
                    v-else
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <v-select v-if="!loaderTagMotivoCita"
                      :options="listadoTagMotivoCita"
                      :filter="filtroTagMotivoCitaDatos"
                      v-model="datosCita.idTagMotivoCita"
                      :reduce="(variable) => variable.idTagMotivoCita"
                      label="descripcionTagMotivoCita"
                      placeholder="Selecciona un motivo de cíta"
                      :disabled="deshabilitarTodo"
                  >
                    <span slot="no-options">No hay motivos de cíta disponibles</span>
                  </v-select>
                  <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
                  <b-spinner small v-if="loaderTagMotivoCita"></b-spinner>
                </validation-provider>
              </b-col>

              <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2">
                <label>{{datosCita.citaEmbajador?"Embajador":"Doctor"}} <validacion v-if="editarFull"/></label>
                <b-spinner small v-if="loaderListadoDoctores"></b-spinner>
                <span v-if="!loaderListadoDoctores && listadoDoctores.length==0 && datosCita.idEmpleado != null">-- Selecciona un doctor --</span>
                <validation-provider
                    v-else-if="!loaderListadoDoctores"
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <b-form-group>
                    <v-select
                        :options="listadoDoctores"
                        :filter="filtroDoctores"
                        v-model="datosCita.idEmpleado"
                        :reduce="(variable) => variable.id"
                        label="nombre"
                        :placeholder="datosCita.citaEmbajador?'Selecciona un Embajador':'Selecciona un Doctor'"
                        :disabled="deshabilitarTodo || !editarFull || datosCita.citaDesdeCal || citaSobreAgendar"
                        @input="llenarEspecialidadesDoctor(true)">
                      <span slot="no-options" v-if="datosCita.citaEmbajador">No hay embajadores disponibles</span>
                      <span slot="no-options" v-else>No hay doctores disponibles</span>
                    </v-select>
                    <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
                <label>Especialidad <validacion/></label>
                <b-spinner small v-if="loaderListadoEspecialidades"></b-spinner>
                <span v-if="!loaderListadoEspecialidades && loaderListadoEspecialidades.length==0 && datosCita.idEspecialidad != null">-- Selecciona un paciente --</span>
                <validation-provider
                    v-else-if="!loaderListadoEspecialidades"
                    :rules="{ required: true }"
                    v-slot="errors">
                  <b-form-group>
                    <v-select
                        id="idEspecialidad"
                        style="width: 100%"
                        :options="listaEspecialidadesDoctor"
                        :filterable="false"
                        @search="filtroEspecialidadesDoctor"
                        v-model="datosCita.idEspecialidad"
                        :reduce="(variable) => variable.id"
                        label="nombre"
                        placeholder="Selecciona una especialidad"
                        :disabled="deshabilitarTodo || !editarFull || datosCita.citaDesdeCal"
                        @input="llenarTratamientos">
                              <span slot="no-options">No hay especialidades disponible</span>
                    </v-select>
                    <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <label>Fecha de la cita</label>
                  <validacion/>
                  <b-form-group>
                    <b-form-datepicker
                        id="fechacita-datepicker"
                        labelNoDateSelected="Fecha"
                        range
                        v-model="datosCita.fechaCita"
                        class="mb-2"
                        :min="fechaMinima"
                        in
                        no-flip
                        :disabled="deshabilitarTodo || datosCita.citaDesdeCal || citaSobreAgendar"
                    ></b-form-datepicker>
                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

          <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Sillón</label>
              <validacion/>
              <b-form-group>
                <v-select v-if="listaClinicas.length>0"
                    placeholder="Selecciona un sillón"
                    :options="listaSillonesClinica"
                    :disabled="deshabilitarTodo || !editarFull || datosCita.citaDesdeCal || citaSobreAgendar"
                    :reduce="(variable) => variable.value"
                    label="text"
                    v-model="datosCita.sillon"
                >
                  <span slot="no-options">No hay sillones disponible</span>
                </v-select>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
              <b-spinner small v-if="listaClinicas.length===0"></b-spinner>
            </validation-provider>
          </b-col>

              <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
                <validation-provider
                    :rules="{ required: true }"
                    v-slot="errors"
                >
                  <label>Hora inicio</label>
                  <validacion/>
                  <b-form-group>
                    <validacion v-if="rangoHoraForm === null && datosCita.fechaCita != null && datosCita.sillon != null "
                                texto="El sillón seleccionado no cuenta con ningún horario" />
                    <span v-else-if="rangoHoraForm === null">--Seleccion una fecha y un sillón--</span>
                    <vue-timepicker v-if="!loaderHorariosClinica && rangoHoraForm != null"
                        id="idHoraInicioNuevaCita"
                        :disabled="deshabilitarTodo || datosCita.citaDesdeCal || citaSobreAgendar"
                        v-model="datosCita.horaInicio"
                        hide-disabled-items
                        format="HH:mm"
                        :minute-interval="15"
                        :hour-range="rangoHoraForm.horas"
                        hide-clear-button
                        @change="valSelectionTime"
                    ></vue-timepicker>

                    <validacion v-if="horaEnRangoInhabilitado"
                               texto="El sillón está inhabilitado en el horario seleccionado"/>
                    <validacion
                        :texto="errors.errors[0] ? errors.errors[0] : ' '"
                    />
                    <b-spinner small v-if="loaderHorariosClinica"></b-spinner>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
                  <label>Duración cita</label>
                  <span>{{ $formatoHorasMinEstandar(datosCita.duracionCita) !== null ? $formatoHorasMinEstandar(datosCita.duracionCita) : "--PENDIENTE--" }}</span>
              </b-col>

              <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
                  <label>Hora fin</label>
                  <span>{{ datosCita.horaFin !== undefined && datosCita.horaFin !== null && datosCita.horaFin !== '' ? datosCita.horaFin : "--PENDIENTE--" }}</span>
              </b-col>

            </b-row>

            <b-row>
              <b-col
                  cols="12"
                  v-if="datosCita.horaFin != null && !rangoHoraFormEsValido()"
              >
                <validacion texto="Completa la información de la cita y verifica los tratamientos para generar un horario válido"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2">
                <div class="detalle-formulario-titulo">
                  <span>Tratamientos agregados</span>
                </div>
              </b-col>
              <b-col xm="12" sm="12" md="12" lg="6" xl="6" class="mb-2" style="text-align: right;">
    <!--            <b-button class="button-dentalia-svg-2" variant="primary"-->
    <!--                      title="Buscar horario"-->
    <!--                      v-if="!mostrarFiltrosTrat"-->
    <!--                      @click="filtrosTrat = null"-->
    <!--            >-->
    <!--              <em class="lupa_svg icon-dentalia-svg-2"></em>-->
    <!--            </b-button>-->
                <b-button class="button-dentalia-svg-2" variant="primary"
                          title="Agregar tratamiento"
                          @click="agregarTratamiento">
                  <em class="plus_svg icon-dentalia-svg-2"></em>
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="4" class="mb-2" style="text-align: left;">
                <strong>Tratamiento</strong>
              </b-col>
              <b-col cols="4" class="mb-2" style="text-align: left;">
                <strong>Pregunta variante de tiempo</strong>
              </b-col>
              <b-col cols="4" class="mb-2" style="text-align: left;">
                <strong>Duración del tratamiento</strong>
              </b-col>
              <b-col cols="12">
                <b-dropdown-divider />
              </b-col>
              <b-col cols="12">
                <b-alert v-if="datosCita.tratamientos==undefined || datosCita.tratamientos==null || datosCita.tratamientos.length === 0 "
                       show variant="warning">No se han agregado tratamientos</b-alert>
                <b-alert v-else-if="datosCita.idEspecialidad==undefined || datosCita.idEspecialidad==null"
                         show variant="warning">Completa los campos de información de la cita para continuar</b-alert>
              </b-col>
            </b-row>

            <div v-if="datosCita.idEspecialidad!==undefined && datosCita.idEspecialidad!==null">
              <b-row v-for="(trat, idx) in datosCita.tratamientos" v-bind:key="idx" class="mb-2" style="margin-top:16px">
                <template v-if="trat.visible">
                  <b-col cols="4" class="mb-2" style="display: grid;">
                    <validation-provider
                        :rules="{ required: true }"
                        v-slot="errors"
                        style="margin-top: auto;"
                    >
                    <!-- <SelectTratamientos :idSeleccionado = "idx" :catalogoTratamientos = "listaTratamientos"/> -->
                    
                      <v-select
                          style="width: 100%;"
                          :options="listaTratamientos"
                          :filter="filtroTratamientos"
                          v-model="trat.idTratamiento"
                          :reduce="(variable) => variable.id"
                          label="nombre"
                          placeholder="Selecciona un tratamiento"
                          @input="seleccionarTratamientoList(trat)">
                        <span slot="no-options">No hay tratamientos disponibles</span>
                      </v-select>
                      <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
                    </validation-provider>
                  </b-col>
                  <b-col cols="4" class="mb-2" style="text-align: left;">
                    <div v-if="
                    listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0] !== undefined
                    && listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0] !== null
                    && listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0].preguntasVariantes !== null
                    && listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0].preguntasVariantes.length > 0" style="margin-top:-18px">
                      <div style="display: flex">
                        <span style=";flex: 1;">
                          {{listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0].nombreVariacionTiempo}}
                        </span>
                        <b-button class="button-dentalia-svg-2 mr-2 ml-2" variant="primary"
                                  style="margin: auto; float:right;"
                                  v-if="trat.infoAyudaAnfitrion !== null"
                                  :id="'infoTrat'+idx">
                          <em class="info_svg icon-dentalia-svg-2" style="height: 13px"></em>
                        </b-button>
                        <b-popover :target="'infoTrat'+idx" triggers="hover" placement="top">
                          <span v-html="listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0].infoAyudaAnfitrion" />
                        </b-popover>
                      </div>

                      <validation-provider
                          :rules="{ required: true }"
                          v-slot="errors"
                      >
                        <v-select
                            class="mt-1"
                            style="width: 100%"
                            :options="listaTratamientos.filter(i=>i.id===trat.idTratamiento)[0].preguntasVariantes"
                            v-model="trat.respuestaVariante"
                            :reduce="(variable) => variable.idTratamientoTiempoSugeridoRespuesta"
                            label="respuesta"
                            placeholder="Selecciona una variante">
                          <span slot="no-options">No hay variantes disponibles</span>
                        </v-select>
                        <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
                      </validation-provider>
                    </div>
                    <div v-else style="    margin-top: 10px;">--SIN VARIACION--</div>
                  </b-col>
                  <b-col cols="4" class="mb-2" style="display: grid;">
                    <div style="width: 90%">
                    <b-form-input v-if="trat.idTratamiento === undefined || trat.idTratamiento === null"
                                  :disabled="true"
                                  v-model="trat.rango" type="range" min="0" max="5"></b-form-input>
                    <b-form-input v-else type="range"
                                  v-model="trat.rango"
                                  step="15"
                                  :min="trat.tiempoMinimoTx"
                                  :max="trat.tiempoMaximoTx"
                                  @change="actualizarDuracionCita"
                    />
                    </div>
                    <div >
                      <div style="display: inline" class="mt-2">{{ trat.rango | formatoHorasMinEstandar}}</div>
                      <div style="margin-top:-55px; margin-left: 92%;">
                      <b-button class="button-dentalia-svg-3 mr-3" variant="primary"
                                title="Quitar tratamiento"
                                @click="quitarTratamiento(idx)">
                        <em class="close_x_svg icon-dentalia-svg-3"></em>
                      </b-button>
                      </div>
                    </div>
                  </b-col>
                </template>
              </b-row>
            </div>

            <b-row class="detalle-formulario mt-5">
          <b-col cols="12">
            <label>Observaciones</label>
            <b-form-textarea v-if="datosCita.comentarioFijo !== undefined && datosCita.comentarioFijo !== null"
                id="idObservaciones"
                v-model="datosCita.comentarioFijo"
                placeholder="Introduce tus observaciones"
                rows="3"
                max-rows="6"
                disabled
            ></b-form-textarea>
            <b-form-group>
              <b-form-textarea
                  id="idObservaciones"
                  v-model="datosCita.comentario"
                  placeholder="Introduce tus observaciones"
                  rows="3"
                  max-rows="6"
                  :disabled="deshabilitarTodo"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col xm="12" sm="12" md="12" lg="4" xl="4" class="mb-2">
            <b-form-checkbox v-model="datosCita.citaAdministrativa" :disabled="deshabilitarTodo || (datosCita.citaReagendar && citaAdministrativaOriginal)">
              ¿La cita es administrativa?
            </b-form-checkbox>
            <label for="cita-administrativa" style="font-style: italic !important;font-size: 11px;">* Si lo seleccionas, <strong>NO</strong> se enviarán correos de confirmación al paciente</label>
          </b-col>
        </b-row>

<!--      </b-tab>-->

<!--      <b-tab title="Tratamientos programados">-->
<!--        <tratProgCitaPaciente-->
<!--            :datosCita="datosCita"/>-->
<!--      </b-tab>-->

<!--    </b-tabs>-->
            <b-row v-if="datosCita !== null && datosCita.esPacienteVIP">
              <b-col class="d-flex justify-content-center">
                <em v-if="datosCita.esPacienteVIP" class="mr-2"  v-b-tooltip.hover.top.v-light
                    title="Este Paciente es MISD"
                    aria-label="Paciente MISD">
                  <font-awesome-icon :icon="['fas', 'crown']" size="md" style="color: #FFD43B;" />
                </em>
                <span>EL PACIENTE AL QUE SE LE ASIGNARÁ LA CITA ES MISD</span>
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col cols="12" style="text-align: center;">
                <b-button
                    variant="outline-info"
                    type="submit"
                    :disabled="disableGuardar"
                >
                  <span v-if="!disableGuardar">Agendar</span>
                  <span v-else>
                        <b-spinner small></b-spinner>
                        Cargando...
                      </span>
                </b-button>
                <b-button
                    variant="outline-secondary"
                    @click="cerrarModal"
                    style="margin-left: 10px"
                >Cancelar</b-button>
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>

    <b-modal
        v-model="mostrarErrorGuardado" hide-header-close hide-footer
        size="md"
    >
      <b-container fluid style="font-size: 14px;">
        <div style="text-align: center" class="mb-4">
          <em class="close_round_svg" style="height: 100px"></em>
        </div>
        <div style="font-weight: bolder; text-align: center;" class="mt-2">La cita sobre agendada no fue guardada</div>
        <div style="font-size: 12px;"  class="mt-2">
          El horario excede el tiempo de la cita original y se sobrepone con la cita de otro paciente, intenta reducir la duración
        </div>
        <div style="text-align: center" class="mt-4">
          <b-button pill @click="mostrarErrorGuardado = false">Enterado</b-button>
        </div>
      </b-container>

    </b-modal>

  </b-container>
</template>

<script>

import {DatosTratamientoCita} from "@/components/NuevaAgenda/nuevaCita/DatosTratamientoCita";
import {DatosCita} from "@/components/NuevaAgenda/nuevaCita/DatosCita";
/* import SelectTratamientos from "@/components/SelectTratamientos" */
// import tratProgCitaPaciente from "@/components/NuevaAgenda/nuevaCita/tratProgCitaPaciente";

export default {
  name: "informacionCitaPaciente",
  components: {
    /* SelectTratamientos */
    // tratProgCitaPaciente,
  },
  props: {
    infoPac: DatosCita,
    editarFull: {
      type: Boolean,
      default: true
    },
    deshabilitarTodo: {
      type: Boolean,
      default: true
    },
    accionFormReagendar: {
      type: Boolean,
      default: false
    },
    accionFormCitaDesdeCalendario: {
      type: Boolean,
      default: false
    },
    idClinica: {
      type: Number,
      default: null
    },
    citaSobreAgendar: {
      type: Boolean,
      default: false
    },
    empleadosEsp: Array
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    datosCita: DatosCita,

    loadingGuardar: false,
    guardando: false,

    loaderTagMotivoCita: false,
    listadoTagMotivoCita: [],

    loaderListadoDoctores: false,
    listadoDoctores: [],

    loaderListadoEspecialidades: false,
    listaEspecialidadesDoctor: [],

    loaderHorariosClinica: false,
    listaClinicas: [],
    horariosClinica: [],
    listaSillonesClinica: [],
    rangoHoraForm: null,

    mostrarFiltrosTrat: false,
    filtrosTrat: null,
    listaTratamientos: [],

    mostrarErrorGuardado: false,
    citaAdministrativaOriginal: false,
  }),
  watch: {
    "infoPac.idPaciente": async function () {
      this.datosCita = JSON.parse(JSON.stringify(this.infoPac));
      this.citaAdministrativaOriginal = this.infoPac.citaAdministrativa || false;
      await this.llenarTagMotivoCitaYDoctores();
      this.actualizarDuracionCita();
      this.buscarHorariosClinica();
    },
    "datosCita.sillon": function () {
      this.actualizarHorarioInicio();
    },
    "datosCita.fechaCita": function () {
      this.buscarHorariosClinica();
    },
    "datosCita.horaInicio": function () {
      this.calcularHoraFin();
    },
  },
  computed: {
    fechaMinima: function () {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    horaEnRangoInhabilitado() {
      if (!this.rangoHoraForm || !this.rangoHoraForm.inhabilitados || !this.rangoHoraForm.inhabilitados.length) return false;
      if (!this.datosCita.horaInicio || !this.datosCita.horaInicio.HH || !this.datosCita.horaInicio.mm) return false;

      const diaFormato = this.$moment(this.datosCita.fechaCita).format("YYYY/MM/DD");
      const horaInicio = this.$moment(diaFormato + " " + this.datosCita.horaInicio.HH + ":" + this.datosCita.horaInicio.mm + ":00");

      return this.rangoHoraForm.inhabilitados.some(inh =>
        horaInicio.isSameOrAfter(inh.horaInicio) && horaInicio.isBefore(inh.horaFin)
      );
    },

    disableGuardar: function() {
      //     this.loaderListadoDoctores,this.loaderListadoEspecialidades,this.loaderHorariosClinica)

      return this.loadingGuardar
          || this.guardando
          || this.loaderTagMotivoCita
          || this.loaderListadoDoctores
          || this.loaderListadoEspecialidades
          || this.loaderHorariosClinica;
    }
  },
  methods: {
    seleccionarTratamiento(data,id){
      this.datosCita.tratamientos[id].idTratamiento = data != null && data != undefined ? data.id : null;
      this.seleccionarTratamientoList(this.datosCita.tratamientos[id])
    },

    filtroTagMotivoCitaDatos(options, search) {
      let seach = search.trim();
      return options.filter(
          (em) => {
            return em.descripcionTagMotivoCita
                .toLowerCase()
                .includes(seach.toLowerCase());
          }
      );
    },

    filtroDoctores(options, search) {
      let seach = search.trim();
      return options.filter((em) => {
        return em.nombre.toLowerCase().includes(seach.toLowerCase());
      });
    },

    filtroEspecialidadesDoctor(options, search) {
      let seach = search.trim();
      return options.filter((em) => {
            return em.nombre.toLowerCase().includes(seach.toLowerCase());
          });
    },

    filtroTratamientos(options, search) {
      let seach = search.trim();
      return options.filter((em) => {
            return em.nombre.toLowerCase().includes(seach.toLowerCase());
          });
    },

    async llenarTagMotivoCitaYDoctores() {
      if (
          this.datosCita !== undefined &&
          this.datosCita !== null &&
          this.datosCita.idPaciente !== undefined &&
          this.datosCita.idPaciente !== null
      ) {
        this.loaderTagMotivoCita = true;
        const params = {
          idPaciente: this.datosCita.idPaciente
        }
        await this.$http.post( this.$api + "tagmotivocita/tagmotivocita/paciente", params  )
            .then((response) => {
              this.listadoTagMotivoCita = response.data.data;
            }).finally(()=>this.loaderTagMotivoCita = false);
      }

      if (
          this.datosCita !== undefined &&
          this.datosCita !== null
      ) {
        if (this.datosCita.citaEmbajador) {
          await this.llenarDoctoresEmbajadorClinica();
        } else {
          await this.llenarDoctoresEspecialistasClinica();
        }
        await this.llenarEspecialidadesDoctor();
      }

      await this.llenarTratamientos(!this.datosCita.citaEdicion);

      if (this.datosCita.citaEdicion && this.datosCita.tratamientos != null) {
        this.datosCita.tratamientos.forEach(it=>{
          this.seleccionarTratamientoList(it);
        });
      }

    },

    async llenarDoctoresEmbajadorClinica() {

      this.listadoDoctores = [];

      if (this.idClinica === undefined || this.idClinica === null || this.idClinica === 0) {
        return;
      }

      this.loaderListadoDoctores = true;

      const parametros = {idClinica: this.idClinica}
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerListaDoctoresEmbajadorClinica", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.listadoDoctores = response.data.data
                  .map((it) => {
                    return {
                      id: it.idEmpleado,
                      nombre:
                          it.numeroEmpleado +
                          " " +
                          it.nombreEmpleado +
                          " (" +
                          this.obtenerEspecialidadesDoctor(it) +
                          ")",
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => (this.loaderListadoDoctores = false));
    },

    async llenarDoctoresEspecialistasClinica() {

      this.listadoDoctores = [];

      if (this.idClinica === undefined || this.idClinica === null || this.idClinica === 0) {
        return;
      }

      if (
          this.datosCita.idPaciente === undefined ||
          this.datosCita.idPaciente == null ||
          this.datosCita.idPaciente === 0
      ) {
        return;
      }

      this.loaderListadoDoctores = true;

      const parametros = {
        idClinica: this.idClinica,
        idPaciente: this.datosCita.idPaciente
      }
      await this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerDoctoresClinicaPaciente", parametros
          )
          .then((response) => {
            this.listadoDoctores.push(
                ...response.data.data
                    .map((it) => {
                      return {
                        id: it.idEmpleado,
                        nombre:
                            it.numeroEmpleado +
                            " " +
                            it.nombreEmpleado +
                            " (" +
                            this.obtenerEspecialidadesDoctor(it) +
                            ")",
                        especialidades: it.especialidades,
                      };
                    })
                    .filter(
                        (x) =>
                            x.especialidades !== undefined &&
                            x.especialidades.some((it00) => it00.idEspecialidad > 1)
                    )
                    .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
            );
          })
          .catch((error) => {
            console.error(error);
          });

      this.listadoDoctores.push(
          ...this.empleadosEsp.filter((it) => {
            let existe = !this.listadoDoctores.some(
                (itSome) => itSome.id === it.id
            );
            return existe;
          })
      );

      this.loaderListadoDoctores = false;

    },

    obtenerEspecialidadesDoctor(doctor) {
      if (
          doctor.especialidades != undefined &&
          doctor.especialidades !== null
      ) {
        return doctor.especialidades
            .map((esp) => esp.nombreEspecialidad)
            .join(", ");
      } else {
        return "-";
      }
    },

    async llenarEspecialidadesDoctor(limpiarEspecialidad=false) {
      this.listaEspecialidadesDoctor = Array();
      if (
          this.datosCita === undefined ||
          this.datosCita.idEmpleado === undefined ||
          this.datosCita.idEmpleado === null ||
          this.datosCita.idEmpleado === 0
      ) {
        return;
      }

      if (limpiarEspecialidad) {
        this.datosCita.idEspecialidad = null;

        if (!this.datosCita.esPacienteNuevo) {
          this.datosCita.idTratamiento = null;
        }
      }

      this.loaderListadoEspecialidades = true;
      const parametros = {idEmpleado: this.datosCita.idEmpleado}
      this.$http
          .post(
              this.$api +
              "colaboradores/obtenerEspecialidadesDoctor", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.listaEspecialidadesDoctor = response.data.data
                  .map((it) => {
                    return {
                      id: it.idEspecialidad,
                      nombre: it.nombreEspecialidad,
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            }
          })
          .catch((error) => {
            this.loaderListadoEspecialidades = false;
            console.error(error);
          })
          .finally(() => {
            this.loaderListadoEspecialidades = false;
            return this.listaEspecialidadesDoctor;
          });
    },

    async llenarTratamientos(limpiarTrats = true) {

      if (limpiarTrats) {
        this.datosCita.tratamientos = [];
      }

      if (
          this.datosCita.idEspecialidad === undefined ||
          this.datosCita.idEspecialidad === null ||
          this.datosCita.idEspecialidad === 0
      ) {
        this.listaTratamientos = Array();
        return;
      }

      const listaEspecialidades = [this.datosCita.idEspecialidad];

      const params = {
        idClinica: this.idClinica,
        idsEspecialidad: listaEspecialidades
      }
      await this.$http
          .put(
              this.$api +
              "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidad", params
          )
          .then((response) => {
            if (response.status === 200) {
              this.listaTratamientos = response.data.data
                  .map((it) => {
                    return {
                      id: it.idTratamiento,
                      nombre: it.nombre,
                      tiempoMinimoTx: it.tiempoMinimoTx,
                      tiempoSugeridoTx: it.tiempoSugeridoTx,
                      tiempoMaximoTx: it.tiempoMaximoTx,
                      nombreVariacionTiempo: it.nombreVariacionTiempo,
                      infoAyudaAnfitrion: it.infoAyudaAnfitrion,
                      preguntasVariantes: it.preguntasVariantes,
                      idTratamientoPadre: it.idTratamientoPadre,
                      idTratamientoNuevo: it.idTratamientoNuevo,
                      isOpen: false
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            }
            this.agregarTratamiento(!this.datosCita.citaEdicion);
          })
          .catch((error) => {
            console.error("error del methos tratamientos", error);
          });
      this.actualizarDuracionCita();
    },

    agregarTratamiento(forzarAgregar = true) {
      if (forzarAgregar || this.datosCita.tratamientos.length === 0) {
        this.datosCita.tratamientos.push(new DatosTratamientoCita());
      }
      this.actualizarDuracionCita();
    },

    quitarTratamiento(idx) {
      this.datosCita.tratamientos.splice(idx, 1);
      this.actualizarDuracionCita();
    },

    async llenarClinicas() {
      this.$http
          .get(this.$api + "catalogos/listaClinicas")
          .then((response) => {
            if (response.status === 200) {
              this.listaClinicas = response.data.data
                  .map((it) => {
                    return {
                      id: it.idClinica,
                      nombre: it.strNombre,
                      numeroSillones: it.numeroSillones,
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            }
          })
          .catch((error) => {
            this.listaClinicas = Array();
            console.error(error);
          });
    },


    async buscarHorariosClinica() {
      if (
          this.idClinica === undefined ||
          this.idClinica === null ||
          this.idClinica === 0 ||
          this.datosCita === undefined ||
          this.datosCita.fechaCita === undefined ||
          this.datosCita.fechaCita === null
      ) {
        return;
      }
      this.listaSillonesClinica = [];
      this.horariosClinica = [];

      this.loaderHorariosClinica = true;

      

      let fechaInicio = null;
      try {
        fechaInicio =
            this.$moment(this.datosCita.fechaCita)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      } catch (e) {
        fechaInicio =
            this.datosCita.fechaCita
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      }



      const parametros = {
        idClinica: this.idClinica,
        fechaInicio: fechaInicio
      }
      await this.$http
          .post(
              this.$api +
              "agenda/obtenerHorariosClinicaParaAgenda", parametros
          )
          .then((response) => {
            if (response.status === 200 && response.data.data !== undefined) {
                response.data.data.forEach((v) => {
                  v.horaInicio = v.horaInicio.toString();

                  if (v.horaInicio.length < 4) {
                    v.horaInicio = "0" + v.horaInicio;
                  }

                  v.horaFin = v.horaFin.toString();
                  if (v.horaFin.length < 4) {
                    v.horaFin = "0" + v.horaFin;
                  }

                  const fechaEvento = this.$moment(v.fecha).utc().format("YYYY/MM/DD");
                  const pos = fechaEvento + "-" + v.sillon;

                  const horaIn = v.horaInicio.substr(0, 2);
                  const horaFn = v.horaFin.substr(0, 2);
                  const minIn = v.horaInicio.substr(2, 3);
                  const minFn = v.horaFin.substr(2, 3);

                  if (this.horariosClinica[pos] === undefined) {
                    this.horariosClinica[pos] = {
                      original: [],
                      horas: [],
                      horasMinutosDate: [],
                      inhabilitados: [],
                    };
                  }

                  if (!v.sillonHabilitado) {
                    this.horariosClinica[pos].inhabilitados.push({
                      horaInicio: this.$moment(fechaEvento + " " + horaIn + ":" + minIn + ":00"),
                      horaFin: this.$moment(fechaEvento + " " + horaFn + ":" + minFn + ":00"),
                    });
                  } else {
                    this.horariosClinica[pos].original.push(
                        horaIn + ":" + minIn + " a " + horaFn + ":" + minFn
                    );
                    this.horariosClinica[pos].horas.push([
                      Number(horaIn),
                      Number(horaFn),
                    ]);
                    this.horariosClinica[pos].horasMinutosDate.push({
                      horaInicio: this.$moment(
                          fechaEvento + " " + horaIn + ":" + minIn + ":00"
                      ),
                      horaFin: this.$moment(
                          fechaEvento + " " + horaFn + ":" + minFn + ":00"
                      ),
                    });
                  }

                });


              if (
                  this.idClinica !== undefined &&
                  this.idClinica > 0 &&
                  this.listaClinicas !== undefined &&
                  this.listaClinicas !== null &&
                  !this.datosCita.citaEmbajador
              ) {
                const clinica = this.listaClinicas.find(
                    (c) => c.id === this.idClinica
                );
                if (clinica !== undefined) {
                  for (let i=1; i<=clinica.numeroSillones; i++) {
                    this.listaSillonesClinica.push({text:i, value:i});
                  }
                }
              }

              this.actualizarHorarioInicio();

            }
          })
          .catch((error) => {
            console.error("No hay datos" + error);
          });

      if (this.datosCita.citaEmbajador) {
        this.listaSillonesClinica = [
          {text: "E1", value: 100},
          {text: "E2", value: 101},
        ];
      }

      this.loaderHorariosClinica = false;
    },

    actualizarHorarioInicio() {
      this.rangoHoraForm = null;
      if (
          this.datosCita.fechaCita !== undefined &&
          this.datosCita.sillon !== undefined
      ) {
        const pos =
            this.$moment(this.datosCita.fechaCita).format("YYYY/MM/DD") +
            "-" +
            this.datosCita.sillon;
        if (this.horariosClinica[pos] !== undefined) {
          this.rangoHoraForm = this.horariosClinica[pos];
        }
      }
    },

    calcularHoraFin() {
      this.datosCita.horaFin = null;

      if (this.datosCita.horaInicio !== undefined && this.datosCita.horaInicio !== null) {
        let fechaHora = this.$moment('2000-01-01 ' + this.datosCita.horaInicio["HH"] + ":" + this.datosCita.horaInicio["mm"]);
        if (fechaHora.isValid()) {
          fechaHora.add(this.datosCita.duracionCita, 'minutes')
          this.datosCita.horaFin = fechaHora.format('HH:mm');
        }
      }
    },

    actualizarDuracionCita() {
      if (this.datosCita.tratamientos !== undefined && this.datosCita.tratamientos !== null) {
        this.datosCita.duracionCita = 0;
        this.datosCita.tratamientos.forEach(it => {
          this.datosCita.duracionCita += Number(it.rango);
        });
      } else {
        this.datosCita.duracionCita = 0;
      }

      /*  const ToTime = (num) => {
        var horas = Math.floor((num / 60) % 60);
        horas = horas < 10 ? '0' + horas : horas;
        var minutos = num % 60;
        minutos = minutos < 10 ? '0' + minutos : minutos;
        return horas + ':' + minutos;
      }*/


      this.calcularHoraFin();
    },

    rangoHoraFormEsValido() {
      const val = this.rangoHoraForm;
      if (
          val !== undefined && val !== null &&
          this.datosCita.horaInicio.HH !== undefined &&
          this.datosCita.horaInicio.mm !== undefined &&
          this.datosCita.horaFin !== undefined &&
          this.datosCita.horaFin !== null
      ) {
        let diaFormato = this.$moment(
            this.datosCita.fechaCita,
            "DD/MM/YYYY"
        ).format("YYYY/MM/DD");
        if (!diaFormato._isValid) {
          diaFormato = this.$moment(this.datosCita.fechaCita).format(
              "YYYY/MM/DD"
          );
        }

        const horaInicio = this.$moment(
            diaFormato +
            " " +
            this.datosCita.horaInicio.HH +
            ":" +
            this.datosCita.horaInicio.mm +
            ":00"
        );
        const horaFin = this.$moment(
            diaFormato +
            " " +
            this.datosCita.horaFin
        );

        if (horaInicio >= horaFin) {
          return false;
        }

        let esValido = false;
        val.horasMinutosDate.forEach((it) => {
          if (horaInicio >= it.horaInicio && horaFin <= it.horaFin) {
            esValido = true;
          }
        });

        if (esValido && val.inhabilitados && val.inhabilitados.length > 0) {
          for (const inh of val.inhabilitados) {
            if (horaInicio.isBefore(inh.horaFin) && horaFin.isAfter(inh.horaInicio)) {
              return false;
            }
          }
        }

        return esValido;
      }
      return false;
    },

    seleccionarTratamientoList(tratDatoCita) {
      const rangoDefault = 15;
      const minDefault = 15;
      const maxDefault = 240;

      const tratListado = this.listaTratamientos.filter(it=>it.id===tratDatoCita.idTratamiento);

      if (tratListado !== undefined && tratListado !== null && tratListado.length > 0) {
        tratDatoCita.tiempoSugeridoTx = tratListado[0].tiempoSugeridoTx != null ? tratListado[0].tiempoSugeridoTx: rangoDefault;
        tratDatoCita.tiempoMinimoTx = tratListado[0].tiempoMinimoTx != null ? tratListado[0].tiempoMinimoTx: minDefault;
        tratDatoCita.tiempoMaximoTx = tratListado[0].tiempoMaximoTx != null ? tratListado[0].tiempoMaximoTx: maxDefault;


        if (tratDatoCita.rango === undefined || tratDatoCita.rango === null) {
          if (tratDatoCita.tiempoSugeridoTx !== undefined && tratDatoCita.tiempoSugeridoTx !== null) {
            tratDatoCita.rango = tratDatoCita.tiempoSugeridoTx;
          } else {
            tratDatoCita.rango = 15;
          }
        }

        if (tratDatoCita.rango < tratDatoCita.tiempoMinimoTx) {
          tratDatoCita.rango = tratDatoCita.tiempoMinimoTx;
        }
      } else {
        tratDatoCita.rango = rangoDefault;
        tratDatoCita.tiempoMinimoTx = minDefault;
        tratDatoCita.tiempoMaximoTx = maxDefault;
      }

      this.actualizarDuracionCita();
    },

    cerrarModal() {
      this.$emit('cerrarModal');
    },

    guardarCita() {

      if (!this.rangoHoraFormEsValido && !this.citaIsOverbooking) {
        this.$swal.fire({
          icon: "error",
          title: "Selecciona un horario válido para poder continuar",
        });
        return;
      }

      if (
          this.datosCita.idPaciente === undefined ||
          this.datosCita.idPaciente == null ||
          this.datosCita.idPaciente === 0
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Debes buscar y seleccionar un paciente",
        });
        return;
      }

      if (
          this.datosCita.sillon === undefined ||
          this.datosCita.sillon == null ||
          this.datosCita.sillon === 0
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Debes seleccionar un sillón",
        });
        return;
      }

      if (
          this.datosCita.tratamientos === undefined ||
          this.datosCita.tratamientos == null ||
          this.datosCita.tratamientos === 0
      ) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Debes agregar al menos un tratamiento",
        });
        return;
      }

      let existeTratDup = null;
      this.datosCita.tratamientos.forEach(trat => {
        const tratDup = this.datosCita.tratamientos.filter(it => it.idTratamiento === trat.idTratamiento);
        if (tratDup.length>1) {
          existeTratDup = tratDup[0].idTratamiento;
          return;
        }
      });

      if (existeTratDup !== null) {
        const tratnombre = this.listaTratamientos.filter(it=>it.id===existeTratDup);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "El tratamiento " + tratnombre[0].nombre + " se encuentra duplicado. Verifica la información",
        });
        return;
      }

      const datosGuardar = JSON.parse(JSON.stringify(this.datosCita));
      datosGuardar.fechaCita = this.$moment(datosGuardar.fechaCita).format("YYYY-MM-DD");

      datosGuardar.horaInicio = Number(datosGuardar.horaInicio.HH + "" + datosGuardar.horaInicio.mm);
      datosGuardar.horaFin = Number(datosGuardar.horaFin.replace(":", ""));
      datosGuardar.idClinica = this.idClinica;

      datosGuardar.citaSobreAgendar = this.citaSobreAgendar;

      this.loadingGuardar = true;

      let urlSave = "agenda/registrarCitav2";
      if (this.datosCita.citaReagendar !== null && this.datosCita.citaReagendar) {
        const fechaInicio =
            this.$moment(datosGuardar.fechaCita)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
        const fechaFin =
            this.$moment(datosGuardar.fechaCita)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
        const params = {
          idClinica: this.idClinica,
          fechaInicio: fechaInicio,
          fechaFin: fechaFin,
          sillon: datosGuardar.sillon,
          horaInicio: datosGuardar.horaInicio,
          horaFin: datosGuardar.horaFin,
        }

        this.$http
            .post(this.$api + "agenda/obtenerHorarioDrSala", params).then((resp) => {
          if (resp.data.data) {
            if (resp.data.data.length === 0) {
              this.loadingGuardar = false
              this.$swal({
                icon: "warning",
                text: " No hay doctor asignado en la fecha y sillón seleccionados. ¿Estás seguro de que quieres continuar?",
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                showCancelButton: true,
                showConfirmButton: true,
              }).then((aceptar) => {
                if (aceptar.value) {
                  urlSave = "agenda/reagendarCitaV2"
                  this.loadingGuardar = true
                  this.mandarAReagendar(urlSave, datosGuardar);
                }
              })
            } else if (datosGuardar.idEmpleado !== resp.data.data[0].idEmpleado) {
              this.loadingGuardar = false
              this.$swal({
                icon: "warning",
                text: " El sillón seleccionado está asignado a otro doctor. ¿Estás seguro de que quieres continuar?",
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                showCancelButton: true,
                showConfirmButton: true,
              }).then((aceptar) => {
                if (aceptar.value) {
                  urlSave = "agenda/reagendarCitaV2"
                  this.loadingGuardar = true
                  this.mandarAReagendar(urlSave, datosGuardar);
                }
              })
            }else{
              urlSave = "agenda/reagendarCitaV2"
              this.loadingGuardar = true
              this.mandarAReagendar(urlSave, datosGuardar);
            }
          }
        }).catch(()=> {this.loadingGuardar = false }).finally(()=> {this.loadingGuardar = false})

      } else {
        this.mandarAReagendar(urlSave, datosGuardar)
      }
    },
    mandarAReagendar(urlSave, datosGuardar) {
      this.$http
          .post(this.$api + urlSave, datosGuardar)
          .then((response) => {
            if (response.status === 200) {

              if (this.citaSobreAgendar) {
                this.$swal.fire({
                  icon: "success",
                  title: "La cita sobreagendada se guardó correctamente",
                });
              } else {
                this.$swal.fire({
                  icon: "success",
                  title: "La cita se registró con éxito",
                });
              }


              this.second = false;

              const datosActualizacion = {
                fecha: new Date(datosGuardar.fechaCita ),
                seleccionDirecta: true,
                registroCita: true,
              }
              this.$emit('guardarNuevaCitaV2', datosActualizacion)
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response) {
              let mensaje = error.response.data.message;
              console.error(mensaje);
              try {
                if (error.response.data.data !== undefined) {
                  mensaje +=
                      " (Fecha bloqueo del " +
                      this.$formatoFecha(
                          error.response.data.data.fechaInicioBloqueo
                      ) +
                      " al " +
                      this.$formatoFecha(
                          error.response.data.data.fechaFinBloqueo
                      ) +
                      " de " +
                      this.$formatoHora(
                          error.response.data.data.horaInicioBloqueo
                      ) +
                      " a " +
                      this.$formatoHora(error.response.data.data.horaFinBloqueo) +
                      ")";
                }
              } catch (e) {
                console.error(e);
              }

              if (this.citaSobreAgendar) {
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: "Horario ocupado",
                });
              }else {
                this.mostrarErrorGuardado = true;
              }
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente",
              });
            }
          })
          .finally(() => (this.loadingGuardar = false));

    },

    limpiarFormulario() {
      if (!this.datosCita.citaDesdeCal) {
        this.datosCita.idEmpleado = null;
        this.datosCita.idEspecialidad = null;
        this.datosCita.fechaCita = null;
        this.datosCita.sillon = null;
        this.datosCita.horaInicio = null;
      }
      this.datosCita.idTagMotivoCita = null;
      this.datosCita.tratamientos = [];
      this.datosCita.comentario = null;
      this.datosCita.citaAdministrativa = false;
    },

    valSelectionTime() {
      if (this.datosCita.horaInicio !== undefined && this.datosCita.horaInicio !== null) {
        if (this.datosCita.horaInicio.mm == null || this.datosCita.horaInicio.mm == null || this.datosCita.horaInicio.mm == "") {
          this.datosCita.horaInicio.mm = "00";
        }
      }
    }

  },
  
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.datosCita = JSON.parse(JSON.stringify(this.infoPac));
    await this.llenarClinicas();
  },
}
</script>

<style>
  #idHoraInicioNuevaCita, #idHoraFinNuevaCita {
    width: 100%;
  }
</style>

<style scoped>
  .time-picker {
    width: 100%;
  }
</style>
